﻿import {ValidationMessage} from '../validationMessage';
import {ValidationMessageType} from '../validationMessageType';
import {InvalidPhone } from '../validationConstants';
import {ValidateResult} from '../validateResult';
import {IValidator} from './iValidator';

export class PhoneValidator implements IValidator {
    private phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

    validate(value: any, propertyName, propertydisplayName, errorMessage): ValidateResult {
       
       let result = new ValidateResult();

        if (this.phoneRegex.test(value)) {
            return result;
        }

        let vm = new ValidationMessage();
        if (typeof errorMessage == 'undefined' || errorMessage == null || errorMessage == '') {
            vm.message = InvalidPhone;
        } else {
            vm.message = errorMessage;
        }
        vm.propertyName = propertyName;
        vm.messageType = ValidationMessageType.Error;
        result.validationMessage = vm;
        return result;
    }

    validatePhone(value: any): Boolean {
         if (this.phoneRegex.test(value)) {
             return true;
         }

         return false;
     }
}